import { COMPONENT_UNIT_TYPES } from "src/plugins/shared/item.config";
import { Tag } from "src/plugins/shared/uvitem.config";

const tags: Record<'tags1', Record<string, Tag>> = {
    tags1: {
        voltage: {
            type: COMPONENT_UNIT_TYPES.Sensor,
            tag: 'voltage',
            description: 'Voltage (f = [x(V) x 1] V)',
            display_suffix: 'V', 
            config: {
              scale: 1,
              decimal_points: 0
            },
            main_key: null,
            command_key: null,
            can_send_command: false,
            command_v: 'v1',
        },
    },
}

export default tags;